import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";

import { db } from "../firebase/firebase";

const defaultSettings = {
  companyName: "Quality Sports Surface",
  phone: "",
  email: "",
  whatsapp: "",
  address: "",
  website: "",
  instagram: "",
  facebook: "",
  youtube: "",
};

const useWebsiteSettings = () => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const settingsRef = doc(db, "settings", "website");

    const unsubscribe = onSnapshot(
      settingsRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setSettings({
            ...defaultSettings,
            ...snapshot.data(),
          });
        } else {
          setSettings(defaultSettings);
        }

        setLoading(false);
      },
      (error) => {
        console.error("Website settings error:", error);

        setSettings(defaultSettings);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  return {
    settings,
    loading,
  };
};

export default useWebsiteSettings;
